/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Xml_Faq_A2Inputs */

const en_to_xml_faq_a2 = /** @type {(inputs: To_Xml_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Array items repeat the element name of the key that held them, producing sibling elements. A top level array is the exception: it is wrapped in a single root element with each entry written as an item element, because XML permits only one root.`)
};

const ko_to_xml_faq_a2 = /** @type {(inputs: To_Xml_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`배열 항목은 그것을 담고 있던 키의 요소 이름을 반복해 형제 요소를 만듭니다. 최상위 배열은 예외로, XML이 루트를 하나만 허용하므로 하나의 루트 요소로 감싸이고 각 항목이 item 요소로 작성됩니다.`)
};

const ja_to_xml_faq_a2 = /** @type {(inputs: To_Xml_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`配列の項目は、それを保持していたキーの要素名を繰り返して兄弟要素を作ります。最上位の配列は例外で、XML がルートを 1 つだけ許すため、1 つのルート要素で包まれ各項目が item 要素として書かれます。`)
};

/**
* | output |
* | --- |
* | "Array items repeat the element name of the key that held them, producing sibling elements. A top level array is the exception: it is wrapped in a single root..." |
*
* @param {To_Xml_Faq_A2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_xml_faq_a2 = /** @type {((inputs?: To_Xml_Faq_A2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Xml_Faq_A2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_xml_faq_a2(inputs)
	if (locale === "ko") return ko_to_xml_faq_a2(inputs)
	return ja_to_xml_faq_a2(inputs)
});